import { ICommonDataState } from './ICommonDataState';
import { McAction } from '../../IMcAction';
import { TeaConfig } from '../../../contracts/common/tea.model';
import { SeverityOfHarm } from '../../../contracts/common/severity-harm.model';
import { DateRange } from '../../../contracts/common/date-range.model';
import { GroupType } from '../../../contracts/common/group-type.model';

export function getAllTeaConfigs(state: ICommonDataState, action: McAction): ICommonDataState {
    return Object.assign({}, state, {
        allTeaConfigs: action.payload
    } as ICommonDataState);
}

export function getSeverityOfHarmValues(state: ICommonDataState, action: McAction): ICommonDataState {
    return Object.assign({}, state, {
        severityOfHarmValues: action.payload
    } as ICommonDataState);
}

export function getDateRangeValues(state: ICommonDataState, action: McAction): ICommonDataState {
    return Object.assign({}, state, {
        dateRangeValues: action.payload
    } as ICommonDataState);
}

export function getDataRangeGroupType(state: ICommonDataState, action: McAction): ICommonDataState {
    return Object.assign({}, state, {
        groupTypes: action.payload
    } as ICommonDataState);
}

export function getQcRuleValues(state: ICommonDataState, action: McAction): ICommonDataState {
    return Object.assign({}, state, {
        qcRules: action.payload
    } as ICommonDataState);
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/modules/common-data/common-data.reducer.logic.ts